<template>

  <div id="space" class="span-full bgdarkblue black" data-type="layout">
    <canvas id="starsCanvas" class="bgdarkblue"></canvas>
    <div class="full-inner">
      <h3 class="pb6" v-html="page.title"></h3>
      
      <!-- EARTH -->
      <div class="planet-wrapper mt5 relative">
        <div id="stars"></div>
        <transition name="simple-fade">
          <div id="planet-popup" class="item-dialog item-dialog-single no-border pt2 pb2 content-500 bgblack" v-if="isPopupActive">
            <a class="close" v-on:click.prevent="closePopup()" href="#"></a>
            <span class="title">{{popupTitle}}</span>
            <span class="content">
              <div class="entry-content">
                {{popupText}}
              </div>
            </span>
          </div>
        </transition>
        <div class="planet">
          <div id="planet-markers-container">
            <div class="planet-markers" v-for="n in 3">
              <a v-for="(point, index) in points" v-on:click="showPopup(index)" :data-x="point.x" :data-y="point.y" :data-name="point.name" :data-text="point.text"></a>
            </div>
          </div>
        </div>
        
        <div class="cloud-wrapper">
          <div class="cloud icon-cloud-right cloud-top-right"></div>
          <div class="cloud icon-cloud-centred cloud-top-left"></div>
          <div class="cloud icon-cloud-right cloud-middle-left"></div>
          <div class="cloud icon-cloud-centred cloud-bottom-left"></div>
          <div class="cloud icon-cloud-left cloud-bottom-right"></div>
        </div>
      </div>

    </div>

    <!-- ELEMENTS -->
    <div id="ovni"></div>
    <div id="satellite"></div>
    <div id="comets">
      <div id="comet1" class="comet"></div>
      <div id="comet2" class="comet"></div>
      <div id="comet3" class="comet"></div>
      <div id="comet4" class="comet"></div>
    </div>
    <a href="#" data-index="0" class="read-more">
      <span class="arrow-down"></span>
    </a>
  </div>
</template>
<script>
  import space from  '../js/Problems-planet-space.js'
  import misc from '../js/scripts.js'
  export default {
    name: 'problems-planet',
    data() {
      return {
        isPopupActive: false,
        page: {},
        showArrow: true,
        popupTitle: '',
        popupText: '',
        points: []
      }
    },
    methods: {
      getUrl(){
        if( this.$route.params.lang === 'en' ){
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problems-planet'
        } else {
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problemas-el-planeta&lang=es'
        }
      },
      loadContent(){
        var getUrl = this.getUrl()
        this.axios.get(this.getUrl()).then((response) => {
          var places = response.data[0].acf.places
          this.page.title = response.data[0].acf.title
          this.points = [];
          places && places.forEach( (el) => {
            this.points.push({
              name: el.name,
              text: el.text,
              x: parseInt(el.pos_x),
              y: parseInt(el.pos_y)
            })
          })
          this.$nextTick(()=>{
            space.initPoints()
            misc.addArrows()
          })
        })
      },
      // Place points in each container
      pauseMarkers(option) {
        var divs = document.querySelectorAll('.planet-markers');
        for (var i = 0; i < divs.length; i++) {
            if(option)
              divs[i].classList.add('paused');
            else
              divs[i].classList.remove('paused');
        }
      },
      showPopup(id) {
        this.pauseMarkers(true);
        this.popupTitle = this.points[id].name;
        this.popupText = this.points[id].text;
        this.isPopupActive = true
      },
      closePopup() {
        this.pauseMarkers(false);
        this.isPopupActive = false
      },
      handleArrow(){
        if( document.body.scrollTop > 200 ){
          this.showArrow = false
        }
        if( document.body.scrollTop === 0 )
          this.showArrow = true
      },
      doArrow(){
        misc.scrollTo2('#swiper-ocean-container', 600);
      }
    },
    created(){
      this.loadContent()
    },
    watch: {
      '$route': 'loadContent'
    },
    mounted() {
      space.initSpace()
      window.addEventListener('scroll', this.handleArrow )
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleArrow )
    }
  }
</script>


// WEBPACK FOOTER //
// Problems-planet.vue?3aed6121